/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var INVALID_DATE = "Invalid Date";
var MIN_YEAR = 1970;
var FIRST_MONTH_OF_YEAR = 1;
var LAST_MONTH_OF_YEAR = 12;
var DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
var DEFAULT_MODE = "month";
var DEFAULT_FIRST_DAY_OF_WEEK = 1;
var DEFAULT_THEME = "full";
var DEFAULT_YEAR_CELL_NUMINROW = 4;
var THEME_LIST = ["full", "card"];
var MODE_LIST = ["month", "year"];
var FIRST_DAY_OF_WEEK_LIST = [1, 2, 3, 4, 5, 6, 7];
var DAY_CN_MAP = {
  1: "\u4E00",
  2: "\u4E8C",
  3: "\u4E09",
  4: "\u56DB",
  5: "\u4E94",
  6: "\u516D",
  7: "\u65E5"
};
var MONTH_CN_MAP = {
  1: "\u4E00\u6708",
  2: "\u4E8C\u6708",
  3: "\u4E09\u6708",
  4: "\u56DB\u6708",
  5: "\u4E94\u6708",
  6: "\u516D\u6708",
  7: "\u4E03\u6708",
  8: "\u516B\u6708",
  9: "\u4E5D\u6708",
  10: "\u5341\u6708",
  11: "\u5341\u4E00\u6708",
  12: "\u5341\u4E8C\u6708"
};
var _const = {
  INVALID_DATE: INVALID_DATE,
  MIN_YEAR: MIN_YEAR,
  FIRST_MONTH_OF_YEAR: FIRST_MONTH_OF_YEAR,
  LAST_MONTH_OF_YEAR: LAST_MONTH_OF_YEAR,
  DEFAULT_DATE_FORMAT: DEFAULT_DATE_FORMAT,
  DEFAULT_MODE: DEFAULT_MODE,
  DEFAULT_FIRST_DAY_OF_WEEK: DEFAULT_FIRST_DAY_OF_WEEK,
  DEFAULT_THEME: DEFAULT_THEME,
  DEFAULT_YEAR_CELL_NUMINROW: DEFAULT_YEAR_CELL_NUMINROW,
  MODE_LIST: MODE_LIST,
  FIRST_DAY_OF_WEEK_LIST: FIRST_DAY_OF_WEEK_LIST,
  THEME_LIST: THEME_LIST,
  DAY_CN_MAP: DAY_CN_MAP,
  MONTH_CN_MAP: MONTH_CN_MAP
};

export { DAY_CN_MAP, DEFAULT_DATE_FORMAT, DEFAULT_FIRST_DAY_OF_WEEK, DEFAULT_MODE, DEFAULT_THEME, DEFAULT_YEAR_CELL_NUMINROW, FIRST_DAY_OF_WEEK_LIST, FIRST_MONTH_OF_YEAR, INVALID_DATE, LAST_MONTH_OF_YEAR, MIN_YEAR, MODE_LIST, MONTH_CN_MAP, THEME_LIST, _const as default };
//# sourceMappingURL=const.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/calendar/const.js
// module id = null
// module chunks = 